import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { InscripcionConvenioService } from 'src/app/services/inscripcion-convenio.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inscripcion-convenio-ejecutivo',
  templateUrl: './inscripcion-convenio-ejecutivo.component.html',
  styleUrls: ['./inscripcion-convenio-ejecutivo.component.css']
})
export class InscripcionConvenioEjecutivoComponent implements OnInit {

  public domainInfo: any = {};
  public todayDate = this.getTodayIsoDate();
  public usuario: any = null;

  public loading = true;
  public loadingSubmit = false;
  public creatingCartSubscription = false;
  public sendingMailPaciente = false;

  public convenioDisponible = true;
  public showSuccessExecutiveScreen = false;

  public currentStep = 1;

  public steps: any = {
    seleccionPlan: true,
    titular: false,
    beneficiarios: false,
    resumenEnvio: false
  };

  public inscripcionForm!: FormGroup;
  public beneficiarioForm!: FormGroup;

  public mostrarModalBeneficiario = false;
  public mostrarModalLimpiar = false;
  public indexBeneficiarioEditando: number | null = null;
  public mostrarDetallePrecioTitular = false;

  public checkingTitularPlanExist = false;
  public titularRutPlanValidationMessage = '';
  private lastTitularPlanValidationKey = '';
  private lastTitularPlanValidationValid: boolean | null = null;
  private lastTitularPlanValidationErrorKey = '';
  private lastTitularPlanValidationMessage = '';

  // Validación automática RUT + plan
  private titularRutValidationTimeout: any = null;
  private readonly TITULAR_RUT_VALIDATION_DELAY = 500;

  public especialidadesExpandidasPorPlan: { [key: string]: boolean } = {};


  public planesDisponibles: any[] = [];

  public cartSubscriptionResponse: any = null;
  public cartSubscriptionPayload: any = null;
  public sendMailResponse: any = null;
  public generatedPatientUrl = '';

  private lastCartPayloadHash = '';

  public areaCodes: any[] = [
    { cou_phone_code: '56', cou_flag: 'fi-cl', cou_min_phone: 9, cou_max_phone: 9 },
    { cou_phone_code: '54', cou_flag: 'fi-ar', cou_min_phone: 10, cou_max_phone: 10 },
    { cou_phone_code: '51', cou_flag: 'fi-pe', cou_min_phone: 9, cou_max_phone: 9 }
  ];

  public selectedAreaCode: any = {
    cou_phone_code: '56',
    cou_flag: 'fi-cl',
    cou_min_phone: 9,
    cou_max_phone: 9
  };

  public flagDropdownOpen = false;
  public cantidadBeneficiariosOpciones: number[] = [1, 2, 3, 4, 5, 6, 7];

  private titularControls = [
    'rut',
    'email',
    'nombre',
    'primerApellido',
    'fechaNacimiento',
    'telefonoCodigo',
    'telefono'
  ];

  constructor(
    private fb: FormBuilder,
    private inscripcionService: InscripcionConvenioService,
    private usuarioService: UsuarioService,
    private encriptacionService: EncriptacionService
  ) { }

  ngOnInit(): void {
    this.usuario = this.encriptacionService.getUserInfo();

    this.initForms();
    this.setEjecutivoDesdeUsuarioLogueado();
    this.getInfoConvenio();
    this.getCodPaises();
    this.setTelefonoValidators(this.selectedAreaCode);
  }

  // =========================================================
  // INIT
  // =========================================================

  private initForms(): void {
    this.inscripcionForm = this.fb.group({
      titular: this.fb.group({
        plan: ['', Validators.required],
        rut: ['', [Validators.required, this.rutChilenoValidator.bind(this)]],
        email: ['', [Validators.required, this.emailFormatoValidator]],
        nombre: ['', [Validators.required, Validators.minLength(2)]],
        primerApellido: ['', [Validators.required, Validators.minLength(2)]],
        segundoApellido: [''],
        fechaNacimiento: ['', [Validators.required, this.fechaNoFuturaValidator]],
        telefonoCodigo: ['56', Validators.required],
        telefono: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
        direccion: [''],
        comuna: [''],
        ciudad: [''],
        ejecutivo: ['']
      }),
      beneficiariosDecision: this.fb.group({
        deseaAgregarBeneficiarios: [null, Validators.required],
        momentoAgregarBeneficiarios: [null],
        cantidadBeneficiariosDespues: [null],
        agregarBeneficiariosAhora: [false]
      }),
      beneficiarios: this.fb.array([]),
      validacionEjecutivo: this.fb.group({
        aceptaRevision: [false, Validators.requiredTrue]
      })
    });

    this.beneficiarioForm = this.createBeneficiarioForm();

    this.titularForm.valueChanges.subscribe(() => {
      this.invalidateCartSubscription();
    });

    this.beneficiariosDecisionForm.valueChanges.subscribe(() => {
      this.invalidateCartSubscription();
    });

    this.beneficiarios.valueChanges.subscribe(() => {
      this.invalidateCartSubscription();
    });
  }

  private getInfoConvenio(): void {
    this.loading = true;

    this.inscripcionService
      .getVerificarCanConvenio()
      .then((result: any) => {
        this.domainInfo = result || {};
        this.convenioDisponible = this.domainInfo?.dataCustomer?.cus_can_convenio_particular === true
          || this.domainInfo?.cus_can_convenio_particular === true;
        this.cargarPlanesDisponibles();
      })
      .catch((error) => {
        console.error('Error getVerificarCanConvenio:', error);
        this.convenioDisponible = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private cargarPlanesDisponibles(): void {
  const beneficios = this.domainInfo?.dataCustomerBenefits;

  if (!Array.isArray(beneficios)) {
    this.planesDisponibles = [];
    return;
  }

  this.planesDisponibles = beneficios
    .filter((plan: any) => Number(plan?.cus_ben_sta_id) === 14)
    .map((plan: any) => {
      return {
        ...plan,
        id: plan.cus_ben_id,
        nombre: plan.cus_ben_name
      };
    });
}

  private getCodPaises(): void {
    this.usuarioService.getCodPaises()
      .then((data: any) => {
        const codigos = Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
            ? data.data
            : [];

        this.areaCodes = codigos.length > 0 ? codigos : this.areaCodes;

        const codigoChile = this.areaCodes.find((item: any) => {
          return String(item.cou_phone_code) === '56';
        });

        this.selectedAreaCode = codigoChile || this.selectedAreaCode;

        this.titularForm.patchValue({
          telefonoCodigo: this.selectedAreaCode.cou_phone_code
        }, { emitEvent: false });

        this.setTelefonoValidators(this.selectedAreaCode);
      })
      .catch((error) => {
        console.error('Error getCodPaises:', error);
        this.setTelefonoValidators(this.selectedAreaCode);
      });
  }

  private setEjecutivoDesdeUsuarioLogueado(): void {
    this.titularForm.patchValue({
      ejecutivo: this.getSellerName()
    }, { emitEvent: false });
  }

  // =========================================================
  // GETTERS FORMULARIO
  // =========================================================

  get titularForm(): FormGroup {
    return this.inscripcionForm.get('titular') as FormGroup;
  }

  get beneficiariosDecisionForm(): FormGroup {
    return this.inscripcionForm.get('beneficiariosDecision') as FormGroup;
  }

  get beneficiarios(): FormArray {
    return this.inscripcionForm.get('beneficiarios') as FormArray;
  }

  get validacionEjecutivoForm(): FormGroup {
    return this.inscripcionForm.get('validacionEjecutivo') as FormGroup;
  }

  // =========================================================
  // HEADER / LOGOS
  // =========================================================

  public getNombreConvenio(): string {
    return this.domainInfo?.dataCustomer?.cus_name
      || this.domainInfo?.convenio_nombre
      || this.domainInfo?.cus_name
      || this.domainInfo?.customer_name
      || 'Nombre del convenio';
  }

  public getLogoDefault(): string {
    return this.domainInfo?.dataDefault?.cus_url_image_web
      || this.domainInfo?.dataDefault?.cus_url_image_mobile
      || '';
  }

  public getLogoCustomer(): string {
    return this.domainInfo?.dataCustomer?.cus_url_image_web
      || this.domainInfo?.dataCustomer?.cus_url_image_mobile
      || '';
  }

  public showLogoCustomer(): boolean {
    const defaultId = this.domainInfo?.dataDefault?.cus_id;
    const customerId = this.domainInfo?.dataCustomer?.cus_id;

    return !!defaultId
      && !!customerId
      && defaultId !== customerId
      && !!this.getLogoCustomer();
  }

  public getNombreDefault(): string {
    return this.domainInfo?.dataDefault?.cus_name || 'AlmaMedis';
  }

  public getNombreCustomer(): string {
    return this.domainInfo?.dataCustomer?.cus_name || 'Convenio';
  }

  public getTelefonoCustomer(): string {
    const telefono = this.domainInfo?.dataCustomer?.cus_url_phone
      || this.domainInfo?.cus_url_phone
      || '800 248 030';

    return this.formatTelefonoConvenio(telefono);
  }

  public getTelefonoCustomerHref(): string {
    const telefono = this.getTelefonoCustomer();

    if (!telefono) {
      return '';
    }

    const normalizedPhone = telefono
      .toString()
      .trim()
      .replace(/(?!^)\+/g, '')
      .replace(/[^0-9+]/g, '');

    return normalizedPhone ? `tel:${normalizedPhone}` : '';
  }

  private formatTelefonoConvenio(telefono: any): string {
    const rawPhone = (telefono || '').toString().trim();

    if (!rawPhone) {
      return '';
    }

    const onlyDigits = rawPhone.replace(/\D/g, '');

    if (/^800\d{6}$/.test(onlyDigits)) {
      return `${onlyDigits.substring(0, 3)} ${onlyDigits.substring(3, 6)} ${onlyDigits.substring(6)}`;
    }

    return rawPhone;
  }


  // =========================================================
  // STEPS
  // =========================================================

  private setStep(step: number): void {
    const previousStep = this.currentStep;

    this.currentStep = step;

    this.steps = {
      seleccionPlan: step === 1,
      titular: step === 2,
      beneficiarios: step === 3,
      resumenEnvio: step === 4
    };

    /*
     * Cada vez que se entra al Step 2 desde otro paso,
     * se valida automáticamente la combinación RUT + plan.
     *
     * Esto evita que el ejecutivo tenga que hacer foco
     * y luego blur sobre el input del RUT.
     */
    if (step === 2 && previousStep !== 2) {
      setTimeout(() => {
        this.validarRutPlanAlEntrarStep2();
      }, 0);
    }
  }

  public goToStep(step: number): void {
    if (step < this.currentStep) {
      this.setStep(step);
    }
  }

  public goToStep1(): void {
    this.setStep(1);
  }

  public goToStep2(): void {
    this.setStep(2);
  }

  public goToStep3(): void {
    this.setStep(3);
  }

  public goToStep4(): void {
    this.setStep(4);
  }

  public prevStep(): void {
    if (this.currentStep > 1) {
      this.setStep(this.currentStep - 1);
    }
  }

  public nextFromStep1(): void {
    this.titularForm.get('plan')?.markAsTouched();

    if (!this.isStep1Valid()) {
      return;
    }

    this.goToStep2();
  }

  public async nextFromStep2(): Promise<void> {
    this.markStep2Touched();

    if (!this.isStep2BaseValid()) {
      return;
    }

    const rutPlanValido = await this.validateTitularRutPlanExist();

    if (!rutPlanValido) {
      return;
    }

    this.goToStep3();
  }

  public nextFromStep3(): void {
    this.markBeneficiariosStepTouched();

    if (!this.isBeneficiariosStepValid()) {
      return;
    }

    if (!this.validarRutsBeneficiariosAntesDeContinuar()) {
      return;
    }

    this.goToStep4();
  }

  public async nextFromStep4(): Promise<void> {
    this.validacionEjecutivoForm.markAllAsTouched();

    if (!this.isStep4Valid()) {
      Swal.fire({
        icon: 'warning',
        title: 'Validación pendiente',
        text: 'Debes revisar y validar los datos del paciente y el plan seleccionado antes de enviar la solicitud.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    await this.enviarSolicitudPaciente();
  }

  // =========================================================
  // VALIDACIONES STEPS
  // =========================================================

  private markStep2Touched(): void {
    this.titularControls.forEach(controlName => {
      this.titularForm.get(controlName)?.markAsTouched();
    });
  }

  private markBeneficiariosStepTouched(): void {
    this.beneficiariosDecisionForm.markAllAsTouched();
    this.beneficiarios.controls.forEach((control: AbstractControl) => control.markAllAsTouched());

    if (this.getAgregarBeneficiariosAhora() && this.mostrarModalBeneficiario) {
      this.beneficiarioForm.markAllAsTouched();
    }
  }

  public isStep1Valid(): boolean {
    return this.titularForm.get('plan')?.valid === true;
  }

  public isStep2Valid(): boolean {
    if (this.checkingTitularPlanExist) {
      return false;
    }

    return this.isStep2BaseValid()
      && this.isCurrentTitularPlanValidationValid();
  }

  private isStep2BaseValid(): boolean {
    return this.titularControls.every(controlName => {
      const control = this.titularForm.get(controlName);

      if (!control) {
        return false;
      }

      if (control.disabled) {
        return true;
      }

      if (controlName === 'rut') {
        const errors = { ...(control.errors || {}) };

        delete errors.titularPlanExiste;
        delete errors.titularPlanNoPermitido;
        delete errors.titularPlanValidationError;

        return Object.keys(errors).length === 0;
      }

      return control.valid;
    });
  }

  private isCurrentTitularPlanValidationValid(): boolean {
    const payload = this.buildBenPlanExistPayload();

    if (!payload.rut_ben || !payload.cus_ben_id) {
      return false;
    }

    const validationKey = this.getTitularPlanValidationKey(payload);

    return this.lastTitularPlanValidationKey === validationKey
      && this.lastTitularPlanValidationValid === true;
  }

  public isBeneficiariosStepValid(): boolean {
    const desea = this.getDeseaAgregarBeneficiarios();

    if (!desea) {
      return false;
    }

    if (desea === 'NO') {
      return true;
    }

    return !!this.getCantidadBeneficiariosDespuesSeleccionada();
  }

  public isStep3Valid(): boolean {
    return this.isBeneficiariosStepValid();
  }

  public isStep4Valid(): boolean {
    return this.isStep1Valid()
      && this.isStep2Valid()
      && this.isBeneficiariosStepValid()
      && this.validacionEjecutivoForm.valid;
  }

  public campoInvalido(form: FormGroup, campo: string): boolean {
    const control = form.get(campo);
    return !!control && control.invalid && control.touched;
  }

  // =========================================================
  // PLANES
  // =========================================================

  public seleccionarPlan(plan: any): void {
    if (!plan) {
      return;
    }

    const planCtrl = this.titularForm.get('plan');
    const planActual = planCtrl?.value;
    const nuevoPlan = plan.id || plan.cus_ben_id;

    /*
     * Solo limpiamos el resultado de RUT + plan cuando
     * el usuario selecciona realmente otro plan.
     *
     * Si vuelve al Step 1 y mantiene el mismo plan,
     * conservamos el resultado anterior para re-aplicarlo
     * automáticamente al volver al Step 2.
     */
    const cambioPlan =
      String(planActual || '') !== String(nuevoPlan || '');

    planCtrl?.setValue(nuevoPlan);
    planCtrl?.markAsTouched();

    if (cambioPlan) {
      this.resetTitularPlanValidationState();
    }

    this.invalidateCartSubscription();
  }

  public esPlanSeleccionado(plan: any): boolean {
    const planId = this.titularForm.get('plan')?.value;

    return String(planId) === String(plan?.id)
      || String(planId) === String(plan?.cus_ben_id);
  }

  public getPlanSeleccionado(): any {
    const planId = this.titularForm.get('plan')?.value;

    if (!planId) {
      return null;
    }

    return this.planesDisponibles.find((plan: any) => {
      return String(plan.cus_ben_id) === String(planId)
        || String(plan.id) === String(planId);
    }) || null;
  }

  public getEspecialidadesPlan(plan: any): any[] {
    if (!plan || !Array.isArray(plan.especialidades)) {
      return [];
    }

    return plan.especialidades;
  }

  public getEspecialidadesPlanSeleccionado(): any[] {
    return this.getEspecialidadesPlan(this.getPlanSeleccionado());
  }

  public getTextoTipoConsulta(especialidad: any): string {
    return especialidad?.spe_is_ondemand ? 'Atención inmediata' : 'Agendamiento';
  }

  public getPlanSubtitulo(plan: any): string {
    if (plan?.cus_ben_text_welcome) {
      return plan.cus_ben_text_welcome;
    }

    if (plan?.cus_ben_description) {
      return plan.cus_ben_description;
    }

    return 'Plan disponible para inscripción';
  }

  public getAgregarBeneficiariosAhora(): boolean {
    return this.beneficiariosDecisionForm.get('agregarBeneficiariosAhora')?.value === true;
  }

  public getDeseaAgregarBeneficiarios(): string | null {
    return this.beneficiariosDecisionForm.get('deseaAgregarBeneficiarios')?.value || null;
  }

  public getMomentoAgregarBeneficiarios(): string | null {
    return this.beneficiariosDecisionForm.get('momentoAgregarBeneficiarios')?.value || null;
  }

  public getCantidadBeneficiariosDespuesSeleccionada(): number | null {
    const value = this.beneficiariosDecisionForm.get('cantidadBeneficiariosDespues')?.value;
    return value ? Number(value) : null;
  }

  public seleccionarDeseaAgregarBeneficiarios(opcion: 'SI' | 'NO'): void {
    if (opcion === 'NO') {
      this.beneficiariosDecisionForm.patchValue({
        deseaAgregarBeneficiarios: 'NO',
        momentoAgregarBeneficiarios: null,
        cantidadBeneficiariosDespues: null,
        agregarBeneficiariosAhora: false
      });

      this.limpiarBeneficiariosSlots();
      this.cerrarModalBeneficiario();
      this.invalidateCartSubscription();
      return;
    }

    this.beneficiariosDecisionForm.patchValue({
      deseaAgregarBeneficiarios: 'SI',
      momentoAgregarBeneficiarios: 'AHORA',
      agregarBeneficiariosAhora: true
    });

    const cantidadSeleccionada = this.getCantidadBeneficiariosDespuesSeleccionada();

    if (cantidadSeleccionada) {
      this.crearBeneficiariosSlots(cantidadSeleccionada);
    }

    this.cerrarModalBeneficiario();
    this.invalidateCartSubscription();
  }

  public seleccionarMomentoAgregarBeneficiarios(opcion: 'AHORA' | 'DESPUES'): void {
    this.beneficiariosDecisionForm.patchValue({
      momentoAgregarBeneficiarios: 'AHORA',
      agregarBeneficiariosAhora: true
    });

    this.cerrarModalBeneficiario();
    this.invalidateCartSubscription();
  }

  public seleccionarCantidadBeneficiariosDespues(cantidad: number): void {
    const cantidadNormalizada = Math.max(1, Number(cantidad || 0));

    this.beneficiariosDecisionForm.patchValue({
      deseaAgregarBeneficiarios: 'SI',
      momentoAgregarBeneficiarios: 'AHORA',
      cantidadBeneficiariosDespues: cantidadNormalizada,
      agregarBeneficiariosAhora: true
    });

    this.crearBeneficiariosSlots(cantidadNormalizada);
    this.cerrarModalBeneficiario();
    this.invalidateCartSubscription();
  }

  public isBeneficiariosAhoraFlow(): boolean {
    return this.getDeseaAgregarBeneficiarios() === 'SI'
      && !!this.getCantidadBeneficiariosDespuesSeleccionada();
  }

  public isBeneficiariosDespuesFlow(): boolean {
    return false;
  }

  public getCantidadBeneficiariosActual(): number {
    if (this.getDeseaAgregarBeneficiarios() !== 'SI') {
      return 0;
    }

    return this.getCantidadBeneficiariosDespuesSeleccionada() || 0;
  }

  /**
   * Indica si el ejecutivo seleccionó al menos un beneficiario.
   *
   * Se utiliza en el Step 4 para mostrar la columna
   * de consultas de beneficiarios solamente cuando corresponde.
   */
  public tieneBeneficiariosSeleccionados(): boolean {
    return this.getCantidadBeneficiariosActual() > 0;
  }

  /**
   * Formatea la cantidad de consultas por especialidad.
   *
   * 0, "0", null, undefined o vacío se muestran como "Ilimitadas".
   */
  public getTextoCantidadConsultas(value: any): string {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return 'Ilimitadas';
    }

    const cantidad = Number(value);

    if (isNaN(cantidad) || cantidad <= 0) {
      return 'Ilimitadas';
    }

    return String(cantidad);
  }

  public getBeneficiariosCompletadosCount(): number {
    return this.getBeneficiariosCompletadosControls().length;
  }

  public isBeneficiarioSlotCompleto(index: number): boolean {
    const control = this.beneficiarios.at(index);

    if (!control) {
      return false;
    }

    return this.isBeneficiarioDataCompleto(control.value) && control.valid;
  }

  public getBeneficiarioSlotTitulo(index: number): string {
    return `Beneficiario ${index + 1}`;
  }

  public getPrecioTitularPlan(plan?: any): number {
    const planData = plan || this.getPlanSeleccionado();
    return this.toNumberPlan(planData?.cus_ben_price_titular);
  }

  public getPrecioCarga1Plan(plan?: any): number {
    const planData = plan || this.getPlanSeleccionado();
    return this.toNumberPlan(planData?.cus_ben_price_carga1);
  }

  public getPrecioCarga2Plan(plan?: any): number {
    const planData = plan || this.getPlanSeleccionado();
    return this.toNumberPlan(planData?.cus_ben_price_carga2);
  }

  public getTotalCargasPlan(plan?: any): number {
    const totalBeneficiarios = this.getCantidadBeneficiariosActual();

    if (totalBeneficiarios <= 0) {
      return 0;
    }

    let total = 0;

    if (totalBeneficiarios >= 1) {
      total += this.getPrecioCarga1Plan(plan);
    }

    if (totalBeneficiarios > 1) {
      total += (totalBeneficiarios - 1) * this.getPrecioCarga2Plan(plan);
    }

    return total;
  }

  public getTotalPlanMensual(plan?: any): number {
    return this.getPrecioTitularPlan(plan) + this.getTotalCargasPlan(plan);
  }

  public toggleDetallePrecioTitular(): void {
    this.mostrarDetallePrecioTitular = !this.mostrarDetallePrecioTitular;
  }

  public getDetallePrecioTitular(): any[] {
    const detalle: any[] = [];

    detalle.push({
      label: 'Titular',
      amount: this.getPrecioTitularPlan()
    });

    const totalBeneficiarios = this.getCantidadBeneficiariosActual();

    for (let index = 0; index < totalBeneficiarios; index++) {
      detalle.push({
        label: `Beneficiario ${index + 1}`,
        amount: this.getAmountBeneficiario(index)
      });
    }

    return detalle;
  }

  public formatPrecioPlan(value: any): string {
    const numberValue = this.toNumberPlan(value);

    return numberValue.toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    });
  }

  /**
   * Formatea una fecha sin provocar el desfase de zona horaria
   * que ocurre con new Date('YYYY-MM-DD').
   */
  public formatFechaPlan(value: any): string {
    if (!value) {
      return '—';
    }

    let date: Date | null = null;

    if (value instanceof Date) {
      date = new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate()
      );
    } else if (typeof value === 'string') {
      const rawValue = value.trim();
      const isoMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/);

      if (isoMatch) {
        date = new Date(
          Number(isoMatch[1]),
          Number(isoMatch[2]) - 1,
          Number(isoMatch[3])
        );
      } else {
        const parsedDate = new Date(rawValue);
        date = isNaN(parsedDate.getTime()) ? null : parsedDate;
      }
    } else {
      const parsedDate = new Date(value);
      date = isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    if (!date || isNaN(date.getTime())) {
      return '—';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  /**
   * El inicio de vigencia corresponde a la fecha actual.
   */
  public getFechaInicioVigenciaPlan(): string {
    return this.todayDate;
  }

  /**
   * Obtiene el día de facturación configurado en el plan.
   */
  public getDiaFacturacionPlan(plan?: any): number | null {
    const planData = plan || this.getPlanSeleccionado();

    return this.getDayFromDateValue(
      planData?.cus_ben_fecha_facturacion
      || planData?.cus_ben_billing_date
      || planData?.fecha_facturacion
    );
  }

  /**
   * Calcula la renovación anual igual que en el perfil paciente:
   * suma un año a la fecha de inicio y alinea el resultado con
   * el día de facturación del plan.
   *
   * La fecha representa el inicio del siguiente ciclo después
   * de completar las 12 facturaciones del periodo anual.
   */
  public getFechaRenovacionAnualPlan(plan?: any): Date | null {
    const diaFacturacion = this.getDiaFacturacionPlan(plan);

    if (!diaFacturacion) {
      return null;
    }

    const inicioVigencia = this.getDateFromIsoString(
      this.getFechaInicioVigenciaPlan()
    );

    if (!inicioVigencia) {
      return null;
    }

    const fechaBaseAnual = new Date(
      inicioVigencia.getFullYear() + 1,
      inicioVigencia.getMonth(),
      inicioVigencia.getDate()
    );

    let fechaRenovacion = this.buildDateWithBillingDay(
      fechaBaseAnual.getFullYear(),
      fechaBaseAnual.getMonth(),
      diaFacturacion
    );

    fechaBaseAnual.setHours(0, 0, 0, 0);
    fechaRenovacion.setHours(0, 0, 0, 0);

    if (fechaRenovacion < fechaBaseAnual) {
      fechaRenovacion = this.buildDateWithBillingDay(
        fechaBaseAnual.getFullYear(),
        fechaBaseAnual.getMonth() + 1,
        diaFacturacion
      );
    }

    return fechaRenovacion;
  }

  /**
   * Convierte YYYY-MM-DD a una fecha local para evitar
   * que Chile muestre el día anterior por conversión UTC.
   */
  private getDateFromIsoString(value: any): Date | null {
    if (!value) {
      return null;
    }

    const raw = value.toString().trim().substring(0, 10);
    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) {
      return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);

    if (!year || !month || !day) {
      return null;
    }

    const date = new Date(year, month - 1, day);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  /**
   * Extrae un día de facturación desde un número,
   * una fecha ISO o una fecha en formato DD-MM-YYYY.
   */
  private getDayFromDateValue(value: any): number | null {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return null;
    }

    if (typeof value === 'number') {
      return this.normalizeBillingDay(value);
    }

    const raw = value.toString().trim();

    if (/^\d{1,2}$/.test(raw)) {
      return this.normalizeBillingDay(Number(raw));
    }

    let match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (match) {
      return this.normalizeBillingDay(Number(match[3]));
    }

    match = raw.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})/);

    if (match) {
      return this.normalizeBillingDay(Number(match[1]));
    }

    const parsedDate = new Date(raw);

    if (!isNaN(parsedDate.getTime())) {
      return this.normalizeBillingDay(parsedDate.getDate());
    }

    return null;
  }

  private normalizeBillingDay(day: number): number | null {
    const normalizedDay = Number(day);

    if (
      isNaN(normalizedDay) ||
      normalizedDay < 1 ||
      normalizedDay > 31
    ) {
      return null;
    }

    return normalizedDay;
  }

  private getLastDayOfMonth(
    year: number,
    monthIndex: number
  ): number {
    return new Date(
      year,
      monthIndex + 1,
      0
    ).getDate();
  }

  private buildDateWithBillingDay(
    year: number,
    monthIndex: number,
    billingDay: number
  ): Date {
    const lastDay = this.getLastDayOfMonth(
      year,
      monthIndex
    );

    const validDay = Math.min(
      billingDay,
      lastDay
    );

    return new Date(
      year,
      monthIndex,
      validDay
    );
  }

  private toNumberPlan(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    const numberValue = Number(value);
    return isNaN(numberValue) ? 0 : numberValue;
  }

  // =========================================================
  // EJECUTIVO / VENDEDOR
  // =========================================================

  private getSellerId(): any {
    return this.usuario?._id
      || this.usuario?.id
      || this.usuario?.use_id
      || this.usuario?.user_id
      || null;
  }

  public getSellerName(): string {
    const nombreCompleto = [
      this.usuario?.use_name || this.usuario?.name || this.usuario?.nombre,
      this.usuario?.use_paternal_surname || this.usuario?.primerApellido,
      this.usuario?.use_maternal_surname || this.usuario?.segundoApellido
    ]
      .filter((item: any) => !!item)
      .join(' ')
      .trim();

    return nombreCompleto
      || this.usuario?.email
      || this.usuario?.use_email
      || 'Ejecutivo AlmaMedis';
  }

  // =========================================================
  // VALIDACIONES INPUTS
  // =========================================================

  public allowOnlyLetters(event: KeyboardEvent): void {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ'´\s]*$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  public allowOnlyNumbers(event: KeyboardEvent): void {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  public allowOnlyRutChars(event: KeyboardEvent): void {
    const regex = /^[0-9kK.\-]$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  public async onRutBlur(): Promise<void> {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    /*
     * Si había una validación automática pendiente,
     * la cancelamos porque validaremos inmediatamente.
     */
    this.clearTitularRutValidationTimeout();

    const rut = rutCtrl.value || '';
    const rutFormateado = this.formatRut(rut);

    rutCtrl.setValue(rutFormateado, { emitEvent: false });
    rutCtrl.markAsTouched();
    rutCtrl.updateValueAndValidity({ emitEvent: false });

    this.refreshBeneficiariosRutValidators();

    await this.validateTitularRutPlanExist();
  }

  /**
   * Valida RUT + plan automáticamente cada vez que se entra
   * al Step 2 y el formulario ya contiene un RUT.
   */
  private async validarRutPlanAlEntrarStep2(): Promise<void> {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    this.clearTitularRutValidationTimeout();

    const rut = (rutCtrl.value || '').toString().trim();

    /*
     * Si aún no existe RUT, onTitularRutInput()
     * se encargará de validar cuando termine de escribirlo.
     */
    if (!rut) {
      return;
    }

    const rutFormateado = this.formatRut(rut);

    rutCtrl.setValue(rutFormateado, { emitEvent: false });
    rutCtrl.updateValueAndValidity({ emitEvent: false });

    this.refreshBeneficiariosRutValidators();

    /*
     * No consultamos el backend si el RUT base es inválido.
     */
    if (
      rutCtrl.hasError('required') ||
      rutCtrl.hasError('rutInvalido')
    ) {
      rutCtrl.markAsTouched();
      return;
    }

    rutCtrl.markAsTouched();

    await this.validateTitularRutPlanExist();
  }

  /**
   * Mientras se escribe el RUT:
   * 1. se invalida el resultado anterior;
   * 2. se espera 500 ms desde la última tecla;
   * 3. se consulta automáticamente cuando el RUT es válido.
   */
  public onTitularRutInput(): void {
    this.resetTitularPlanValidationState();
    this.clearTitularRutValidationTimeout();
    this.refreshBeneficiariosRutValidators();
    this.invalidateCartSubscription();

    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    rutCtrl.updateValueAndValidity({ emitEvent: false });

    if (
      !rutCtrl.value ||
      rutCtrl.hasError('required') ||
      rutCtrl.hasError('rutInvalido') ||
      !this.getPlanSeleccionado()
    ) {
      return;
    }

    this.titularRutValidationTimeout = setTimeout(async () => {
      const currentRutCtrl = this.titularForm.get('rut');

      if (
        !currentRutCtrl ||
        !currentRutCtrl.value ||
        currentRutCtrl.hasError('required') ||
        currentRutCtrl.hasError('rutInvalido') ||
        !this.getPlanSeleccionado()
      ) {
        return;
      }

      currentRutCtrl.markAsTouched();

      await this.validateTitularRutPlanExist();

    }, this.TITULAR_RUT_VALIDATION_DELAY);
  }

  private clearTitularRutValidationTimeout(): void {
    if (this.titularRutValidationTimeout) {
      clearTimeout(this.titularRutValidationTimeout);
      this.titularRutValidationTimeout = null;
    }
  }

  private resetTitularPlanValidationState(): void {
    this.lastTitularPlanValidationKey = '';
    this.lastTitularPlanValidationValid = null;
    this.lastTitularPlanValidationErrorKey = '';
    this.lastTitularPlanValidationMessage = '';
    this.clearTitularPlanExistErrors();
  }

  private clearTitularPlanExistErrors(): void {
    const rutCtrl = this.titularForm?.get('rut');

    this.titularRutPlanValidationMessage = '';

    if (!rutCtrl?.errors) {
      return;
    }

    const errors = { ...rutCtrl.errors };

    delete errors.titularPlanExiste;
    delete errors.titularPlanNoPermitido;
    delete errors.titularPlanValidationError;

    rutCtrl.setErrors(Object.keys(errors).length ? errors : null);
  }

  private hasOnlyBaseRutErrors(): boolean {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl?.errors) {
      return false;
    }

    const errors = { ...rutCtrl.errors };

    delete errors.titularPlanExiste;
    delete errors.titularPlanNoPermitido;
    delete errors.titularPlanValidationError;

    return Object.keys(errors).length > 0;
  }

  private setTitularPlanExistError(errorKey: string, message: string): void {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    this.titularRutPlanValidationMessage = message;

    rutCtrl.setErrors({
      ...(rutCtrl.errors || {}),
      [errorKey]: true
    });

    rutCtrl.markAsTouched();
  }

  public shouldShowTitularPlanValidationMessage(): boolean {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl || !this.titularRutPlanValidationMessage) {
      return false;
    }

    return rutCtrl.touched && (
      rutCtrl.hasError('titularPlanExiste') ||
      rutCtrl.hasError('titularPlanNoPermitido') ||
      rutCtrl.hasError('titularPlanValidationError')
    );
  }

  private buildBenPlanExistPayload(): any {
    const planSeleccionado = this.getPlanSeleccionado();

    return {
      rut_ben: this.cleanRutForPayload(this.titularForm.get('rut')?.value),
      cus_ben_id: Number(
        planSeleccionado?.cus_ben_id ||
        planSeleccionado?.id ||
        this.titularForm.get('plan')?.value ||
        0
      )
    };
  }

  private getTitularPlanValidationKey(payload: any): string {
    return `${payload?.rut_ben || ''}|${payload?.cus_ben_id || ''}`;
  }

  private cacheTitularPlanValidationResult(
    validationKey: string,
    valid: boolean,
    errorKey: string = '',
    message: string = ''
  ): void {
    this.lastTitularPlanValidationKey = validationKey;
    this.lastTitularPlanValidationValid = valid;
    this.lastTitularPlanValidationErrorKey = errorKey;
    this.lastTitularPlanValidationMessage = message;
  }

  public async validateTitularRutPlanExist(): Promise<boolean> {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return false;
    }

    this.clearTitularPlanExistErrors();
    rutCtrl.updateValueAndValidity({ emitEvent: false });

    if (this.hasOnlyBaseRutErrors()) {
      return false;
    }

    const payload = this.buildBenPlanExistPayload();

    if (!payload.rut_ben || !payload.cus_ben_id) {
      return false;
    }

    const validationKey = this.getTitularPlanValidationKey(payload);

    if (this.lastTitularPlanValidationKey === validationKey) {
      if (this.lastTitularPlanValidationValid === true) {
        return true;
      }

      if (this.lastTitularPlanValidationValid === false) {
        this.setTitularPlanExistError(
          this.lastTitularPlanValidationErrorKey || 'titularPlanValidationError',
          this.lastTitularPlanValidationMessage || 'El RUT ingresado no puede contratar este plan.'
        );

        return false;
      }
    }

    this.checkingTitularPlanExist = true;

    try {
      const response: any = await (this.inscripcionService as any).postBenPlanExist(payload);
      const validationResult = this.getBenPlanExistValidationResult(response);

      this.cacheTitularPlanValidationResult(
        validationKey,
        validationResult.valid,
        validationResult.errorKey,
        validationResult.message
      );

      if (!validationResult.valid) {
        this.setTitularPlanExistError(
          validationResult.errorKey,
          validationResult.message
        );

        return false;
      }

      return true;

    } catch (error) {
      console.error('Error postBenPlanExist:', error);

      const message = this.getBackendErrorMessage(
        error,
        'No fue posible validar si el RUT puede contratar este plan. Intenta nuevamente.'
      );

      this.cacheTitularPlanValidationResult(
        validationKey,
        false,
        'titularPlanValidationError',
        message
      );

      this.setTitularPlanExistError(
        'titularPlanValidationError',
        message
      );

      return false;

    } finally {
      this.checkingTitularPlanExist = false;
    }
  }

  private getBenPlanExistValidationResult(response: any): { valid: boolean; errorKey: string; message: string } {
    const data = response?.data !== undefined
      ? response.data
      : response?.result !== undefined
        ? response.result
        : response;

    const defaultExistsMessage = 'El RUT ingresado ya tiene este plan contratado.';
    const defaultNotAllowedMessage = 'El RUT ingresado no puede contratar este servicio.';
    const responseMessage = response?.message || data?.message || data?.msg || '';

    if (Array.isArray(data) && data.length > 0) {
      return {
        valid: false,
        errorKey: 'titularPlanExiste',
        message: responseMessage || defaultExistsMessage
      };
    }

    const exists = this.parseBooleanOptional(
      data?.exists ??
      data?.exist ??
      data?.ben_plan_exist ??
      data?.plan_exist ??
      data?.is_exist ??
      data?.hasPlan ??
      data?.alreadyExists ??
      response?.exists ??
      response?.exist
    );

    if (exists === true) {
      return {
        valid: false,
        errorKey: 'titularPlanExiste',
        message: responseMessage || defaultExistsMessage
      };
    }

    const canContract = this.parseBooleanOptional(
      data?.can_contract ??
      data?.canContract ??
      data?.puede_contratar ??
      data?.puedeContratar ??
      data?.canSubscribe ??
      data?.valid
    );

    if (canContract === false) {
      return {
        valid: false,
        errorKey: 'titularPlanNoPermitido',
        message: responseMessage || defaultNotAllowedMessage
      };
    }

    const ok = this.parseBooleanOptional(
      response?.ok ??
      response?.success ??
      data?.ok ??
      data?.success
    );

    if (ok === false) {
      return {
        valid: false,
        errorKey: 'titularPlanNoPermitido',
        message: responseMessage || defaultNotAllowedMessage
      };
    }

    return {
      valid: true,
      errorKey: '',
      message: ''
    };
  }

  private parseBooleanOptional(value: any): boolean | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    const normalizedValue = value.toString().trim().toLowerCase();

    if (['true', '1', 'si', 'sí', 's', 'yes', 'y'].includes(normalizedValue)) {
      return true;
    }

    if (['false', '0', 'no', 'n'].includes(normalizedValue)) {
      return false;
    }

    return null;
  }

  private getBackendErrorMessage(error: any, defaultMessage: string): string {
    if (!error) {
      return defaultMessage;
    }

    if (error?.error?.message) {
      return error.error.message;
    }

    if (error?.error?.data?.message) {
      return error.error.data.message;
    }

    if (error?.message) {
      return error.message;
    }

    if (typeof error?.error === 'string') {
      try {
        const parsedError = JSON.parse(error.error);

        if (parsedError?.message) {
          return parsedError.message;
        }
      } catch (_) {
        return error.error;
      }
    }

    return defaultMessage;
  }


  public onBeneficiarioRutBlur(): void {
    const rutCtrl = this.beneficiarioForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    const rut = rutCtrl.value || '';
    const rutFormateado = this.formatRut(rut);

    rutCtrl.setValue(rutFormateado, { emitEvent: false });
    rutCtrl.markAsTouched();
    rutCtrl.updateValueAndValidity({ emitEvent: false });
  }

  public rutChilenoValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    const rut = this.normalizeRut(value);

    if (rut.length < 2) {
      return { rutInvalido: true };
    }

    const cuerpo = rut.slice(0, -1);
    const dv = rut.slice(-1).toUpperCase();

    if (!/^\d+$/.test(cuerpo)) {
      return { rutInvalido: true };
    }

    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += Number(cuerpo.charAt(i)) * multiplo;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    const dvEsperadoNumero = 11 - (suma % 11);
    let dvEsperado = '';

    if (dvEsperadoNumero === 11) {
      dvEsperado = '0';
    } else if (dvEsperadoNumero === 10) {
      dvEsperado = 'K';
    } else {
      dvEsperado = String(dvEsperadoNumero);
    }

    return dv === dvEsperado ? null : { rutInvalido: true };
  }


  public emailFormatoValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').toString().trim();

    if (!value) {
      return null;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    return emailRegex.test(value) ? null : { emailFormatoInvalido: true };
  }

  public fechaNoFuturaValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    const fechaIngresada = new Date(`${value}T00:00:00`);

    if (isNaN(fechaIngresada.getTime())) {
      return { fechaInvalida: true };
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    return fechaIngresada > hoy ? { fechaMayorActual: true } : null;
  }

  private getTodayIsoDate(): string {
    const hoy = new Date();
    const year = hoy.getFullYear();
    const month = String(hoy.getMonth() + 1).padStart(2, '0');
    const day = String(hoy.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  private formatRut(rut: any): string {
    const clean = this.normalizeRut(rut);

    if (!clean) {
      return '';
    }

    if (clean.length === 1) {
      return clean;
    }

    const cuerpo = clean.slice(0, -1);
    const dv = clean.slice(-1);

    return `${cuerpo}-${dv}`;
  }

  private normalizeRut(rut: any): string {
    return (rut || '')
      .toString()
      .replace(/[^0-9kK]/g, '')
      .toUpperCase();
  }

  public onTelefonoInput(event: any): void {
    const value = (event.target.value || '').toString().replace(/\D/g, '');
    this.titularForm.get('telefono')?.setValue(value, { emitEvent: false });
    this.titularForm.get('telefono')?.markAsDirty();
    this.titularForm.get('telefono')?.updateValueAndValidity({ emitEvent: false });
    this.invalidateCartSubscription();
  }



  public getTelefonoDigitsCount(): number {
    const telefono = this.titularForm.get('telefono')?.value || '';

    return telefono.toString().replace(/\D/g, '').length;
  }

  public getTelefonoMinDigits(): number {
    return Number(this.selectedAreaCode?.cou_min_phone || 8);
  }

  public getTelefonoMaxDigits(): number {
    return Number(this.selectedAreaCode?.cou_max_phone || 15);
  }

  public getTelefonoMissingDigits(): number {
    const minDigits = this.getTelefonoMinDigits();
    const currentDigits = this.getTelefonoDigitsCount();

    return Math.max(minDigits - currentDigits, 0);
  }

  public shouldShowTelefonoMissingMessage(): boolean {
    const telefonoCtrl = this.titularForm.get('telefono');

    if (!telefonoCtrl) {
      return false;
    }

    return this.getTelefonoDigitsCount() > 0
      && this.getTelefonoMissingDigits() > 0;
  }

  public getTelefonoRemainingMessage(): string {
    const missingDigits = this.getTelefonoMissingDigits();

    if (missingDigits <= 0) {
      return '';
    }

    const suffix = missingDigits === 1 ? 'número' : 'números';

    return `Te falta${missingDigits === 1 ? '' : 'n'} ${missingDigits} ${suffix} por ingresar.`;
  }

  // =========================================================
  // CÓDIGO DE ÁREA
  // =========================================================

  public toggleFlagDropdown(): void {
    this.flagDropdownOpen = !this.flagDropdownOpen;
  }

  public selectAreaCode(areaCode: any): void {
    this.selectedAreaCode = areaCode;

    this.titularForm.patchValue({
      telefonoCodigo: areaCode.cou_phone_code
    });

    this.flagDropdownOpen = false;
    this.setTelefonoValidators(areaCode);
    this.invalidateCartSubscription();
  }

  private setTelefonoValidators(areaCode: any): void {
    const min = Number(areaCode?.cou_min_phone || 0);
    const max = Number(areaCode?.cou_max_phone || 15);
    const telefonoCtrl = this.titularForm.get('telefono');

    if (!telefonoCtrl) {
      return;
    }

    telefonoCtrl.setValidators([
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(min),
      Validators.maxLength(max)
    ]);

    telefonoCtrl.updateValueAndValidity({ emitEvent: false });
  }

  // =========================================================
  // BENEFICIARIOS
  // =========================================================

  private createBeneficiarioForm(): FormGroup {
    return this.fb.group({
      rut: [
        '',
        [
          Validators.required,
          this.rutChilenoValidator.bind(this),
          this.beneficiarioNoEsTitularValidator.bind(this),
          this.beneficiarioRutDuplicadoValidator.bind(this)
        ]
      ],
      email: ['', [Validators.required, this.emailFormatoValidator]],
      nombre: ['', [Validators.required, Validators.minLength(2)]],
      primerApellido: ['', [Validators.required, Validators.minLength(2)]],
      segundoApellido: [''],
      fechaNacimiento: ['', [Validators.required, this.fechaNoFuturaValidator]]
    });
  }

  private createBeneficiarioGroup(data?: any): FormGroup {
    return this.fb.group({
      rut: [
        data?.rut || '',
        [
          Validators.required,
          this.rutChilenoValidator.bind(this),
          this.beneficiarioNoEsTitularValidator.bind(this),
          this.beneficiarioRutDuplicadoValidator.bind(this)
        ]
      ],
      email: [data?.email || '', [Validators.required, this.emailFormatoValidator]],
      nombre: [data?.nombre || '', [Validators.required, Validators.minLength(2)]],
      primerApellido: [data?.primerApellido || '', [Validators.required, Validators.minLength(2)]],
      segundoApellido: [data?.segundoApellido || ''],
      fechaNacimiento: [data?.fechaNacimiento || '', [Validators.required, this.fechaNoFuturaValidator]]
    });
  }


  private beneficiarioNoEsTitularValidator(control: AbstractControl): ValidationErrors | null {
    const rutBeneficiario = this.normalizeRut(control.value);
    const rutTitular = this.normalizeRut(this.titularForm?.get('rut')?.value);

    if (!rutBeneficiario || !rutTitular) {
      return null;
    }

    return rutBeneficiario === rutTitular ? { rutIgualTitular: true } : null;
  }

  private beneficiarioRutDuplicadoValidator(control: AbstractControl): ValidationErrors | null {
    const rutBeneficiario = this.normalizeRut(control.value);

    if (!rutBeneficiario || !this.beneficiarios) {
      return null;
    }

    const currentIndexInArray = this.beneficiarios.controls.findIndex((beneficiarioControl: AbstractControl) => {
      return beneficiarioControl.get('rut') === control;
    });

    const indexToIgnore = currentIndexInArray >= 0
      ? currentIndexInArray
      : this.indexBeneficiarioEditando;

    const duplicated = this.beneficiarios.controls.some((beneficiarioControl: AbstractControl, index: number) => {
      if (indexToIgnore !== null && index === indexToIgnore) {
        return false;
      }

      const rutExistente = this.normalizeRut(beneficiarioControl.get('rut')?.value);
      return !!rutExistente && rutExistente === rutBeneficiario;
    });

    return duplicated ? { rutBeneficiarioDuplicado: true } : null;
  }

  private refreshBeneficiariosRutValidators(): void {
    if (!this.inscripcionForm) {
      return;
    }

    const modalRutCtrl = this.beneficiarioForm?.get('rut');

    if (modalRutCtrl) {
      modalRutCtrl.updateValueAndValidity({ emitEvent: false });
    }

    this.beneficiarios.controls.forEach((control: AbstractControl) => {
      control.get('rut')?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private setBeneficiarioRutError(index: number, errorKey: string): void {
    const rutCtrl = this.beneficiarios.at(index)?.get('rut');

    if (!rutCtrl) {
      return;
    }

    rutCtrl.setErrors({
      ...(rutCtrl.errors || {}),
      [errorKey]: true
    });

    rutCtrl.markAsTouched();
  }

  private validarRutsBeneficiariosAntesDeContinuar(): boolean {
    this.refreshBeneficiariosRutValidators();

    const rutTitular = this.normalizeRut(this.titularForm.get('rut')?.value);
    const rutsIngresados: { [rut: string]: number } = {};

    for (let index = 0; index < this.beneficiarios.length; index++) {
      const control = this.beneficiarios.at(index);
      const data = control.value || {};
      const rutBeneficiario = this.normalizeRut(data.rut);

      if (!rutBeneficiario || !this.isBeneficiarioDataCompleto(data)) {
        continue;
      }

      if (rutTitular && rutBeneficiario === rutTitular) {
        this.setBeneficiarioRutError(index, 'rutIgualTitular');

        Swal.fire({
          icon: 'warning',
          title: 'RUT de beneficiario no permitido',
          text: 'El RUT del beneficiario no puede ser el mismo que el RUT del titular.',
          confirmButtonText: 'Aceptar'
        });

        return false;
      }

      if (rutsIngresados[rutBeneficiario] !== undefined) {
        this.setBeneficiarioRutError(index, 'rutBeneficiarioDuplicado');
        this.setBeneficiarioRutError(rutsIngresados[rutBeneficiario], 'rutBeneficiarioDuplicado');

        Swal.fire({
          icon: 'warning',
          title: 'RUT de beneficiario repetido',
          text: 'No puedes ingresar dos beneficiarios con el mismo RUT.',
          confirmButtonText: 'Aceptar'
        });

        return false;
      }

      rutsIngresados[rutBeneficiario] = index;
    }

    return true;
  }

  private crearBeneficiariosSlots(cantidad: number): void {
    const totalSlots = Math.max(0, Number(cantidad || 0));

    while (this.beneficiarios.length < totalSlots) {
      this.beneficiarios.push(this.createBeneficiarioGroup());
    }

    while (this.beneficiarios.length > totalSlots) {
      this.beneficiarios.removeAt(this.beneficiarios.length - 1);
    }

    if (
      this.indexBeneficiarioEditando !== null
      && this.indexBeneficiarioEditando >= this.beneficiarios.length
    ) {
      this.cerrarModalBeneficiario();
    }
  }

  private limpiarBeneficiariosSlots(): void {
    while (this.beneficiarios.length > 0) {
      this.beneficiarios.removeAt(0);
    }
  }

  private isBeneficiarioDataCompleto(data: any): boolean {
    return !!(
      data?.rut
      && data?.nombre
      && data?.primerApellido
      && data?.email
      && data?.fechaNacimiento
    );
  }

  private getBeneficiariosCompletadosControls(): Array<{ control: AbstractControl; index: number }> {
    return this.beneficiarios.controls
      .map((control: AbstractControl, index: number) => ({ control, index }))
      .filter((item) => {
        return this.isBeneficiarioDataCompleto(item.control.value) && item.control.valid;
      });
  }

  public abrirModalAgregarBeneficiario(index?: number): void {
    const cantidadSeleccionada = this.getCantidadBeneficiariosDespuesSeleccionada();

    if (!cantidadSeleccionada) {
      this.beneficiariosDecisionForm.get('cantidadBeneficiariosDespues')?.markAsTouched();
      return;
    }

    if (this.beneficiarios.length !== cantidadSeleccionada) {
      this.crearBeneficiariosSlots(cantidadSeleccionada);
    }

    const slotIndex = index !== undefined && index !== null
      ? index
      : this.beneficiarios.controls.findIndex((control: AbstractControl) => !this.isBeneficiarioDataCompleto(control.value));

    this.indexBeneficiarioEditando = slotIndex >= 0 ? slotIndex : null;
    this.beneficiarioForm = this.createBeneficiarioForm();

    if (this.indexBeneficiarioEditando !== null) {
      const beneficiario = this.beneficiarios.at(this.indexBeneficiarioEditando)?.value;

      if (this.isBeneficiarioDataCompleto(beneficiario)) {
        this.beneficiarioForm.patchValue({
          rut: beneficiario.rut,
          email: beneficiario.email || '',
          nombre: beneficiario.nombre,
          primerApellido: beneficiario.primerApellido,
          segundoApellido: beneficiario.segundoApellido,
          fechaNacimiento: beneficiario.fechaNacimiento
        });
      }
    }

    this.mostrarModalBeneficiario = true;
  }

  public editarBeneficiario(index: number): void {
    this.abrirModalAgregarBeneficiario(index);
  }

  public cerrarModalBeneficiario(): void {
    this.mostrarModalBeneficiario = false;
    this.indexBeneficiarioEditando = null;
    this.beneficiarioForm.reset();
  }

  public guardarBeneficiario(): void {
    this.beneficiarioForm.get('rut')?.updateValueAndValidity({ emitEvent: false });

    if (this.beneficiarioForm.invalid) {
      this.beneficiarioForm.markAllAsTouched();
      return;
    }

    const data = this.beneficiarioForm.value;

    if (this.indexBeneficiarioEditando !== null) {
      this.beneficiarios.at(this.indexBeneficiarioEditando).patchValue(data);
    } else {
      const firstEmptyIndex = this.beneficiarios.controls.findIndex((control: AbstractControl) => {
        return !this.isBeneficiarioDataCompleto(control.value);
      });

      if (firstEmptyIndex >= 0) {
        this.beneficiarios.at(firstEmptyIndex).patchValue(data);
      } else {
        this.beneficiarios.push(this.createBeneficiarioGroup(data));
        this.beneficiariosDecisionForm.patchValue({
          cantidadBeneficiariosDespues: this.beneficiarios.length
        }, { emitEvent: false });
      }
    }

    this.refreshBeneficiariosRutValidators();
    this.invalidateCartSubscription();
    this.cerrarModalBeneficiario();
  }

  public eliminarBeneficiario(index: number): void {
    const control = this.beneficiarios.at(index);

    if (!control) {
      return;
    }

    control.reset({
      rut: '',
      email: '',
      nombre: '',
      primerApellido: '',
      segundoApellido: '',
      fechaNacimiento: ''
    });

    if (this.indexBeneficiarioEditando === index) {
      this.cerrarModalBeneficiario();
    }

    this.refreshBeneficiariosRutValidators();
    this.invalidateCartSubscription();
  }

  // =========================================================
  // LIMPIAR FORMULARIO
  // =========================================================

  public abrirModalLimpiar(): void {
    this.mostrarModalLimpiar = true;
  }

  public cerrarModalLimpiar(): void {
    this.mostrarModalLimpiar = false;
  }

  public limpiarFormulario(): void {
    this.inscripcionForm.reset({
      titular: {
        plan: '',
        rut: '',
        email: '',
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        fechaNacimiento: '',
        telefonoCodigo: '56',
        telefono: '',
        direccion: '',
        comuna: '',
        ciudad: '',
        ejecutivo: this.getSellerName()
      },
      beneficiariosDecision: {
        deseaAgregarBeneficiarios: null,
        momentoAgregarBeneficiarios: null,
        cantidadBeneficiariosDespues: null,
        agregarBeneficiariosAhora: false
      },
      validacionEjecutivo: {
        aceptaRevision: false
      }
    });

    while (this.beneficiarios.length > 0) {
      this.beneficiarios.removeAt(0);
    }

    this.selectedAreaCode = {
      cou_phone_code: '56',
      cou_flag: 'fi-cl',
      cou_min_phone: 9,
      cou_max_phone: 9
    };

    this.setTelefonoValidators(this.selectedAreaCode);

    this.inscripcionForm.markAsPristine();
    this.inscripcionForm.markAsUntouched();

    this.mostrarModalLimpiar = false;
    this.showSuccessExecutiveScreen = false;
    this.cartSubscriptionResponse = null;
    this.cartSubscriptionPayload = null;
    this.sendMailResponse = null;
    this.generatedPatientUrl = '';
    this.lastCartPayloadHash = '';

    this.clearTitularRutValidationTimeout();
    this.resetTitularPlanValidationState();

    this.goToStep1();
  }

  // =========================================================
  // CARRO / SOLICITUD EJECUTIVO
  // =========================================================

  private invalidateCartSubscription(): void {
    this.lastCartPayloadHash = '';
    this.sendMailResponse = null;
  }

  private cleanRutForPayload(rut: any): string {
    return (rut || '').toString().replace(/\./g, '').trim();
  }

  private getTelefonoCompletoTitular(): string {
    const titular = this.titularForm.value;
    const codigo = (titular.telefonoCodigo || '').toString().replace('+', '');
    const telefono = (titular.telefono || '').toString().replace(/\D/g, '');

    if (!codigo && !telefono) {
      return '';
    }

    return `+${codigo}${telefono}`;
  }

  private getAmountBeneficiario(index: number): number {
    if (index === 0) {
      return this.getPrecioCarga1Plan();
    }

    return this.getPrecioCarga2Plan();
  }

  private getPersonTypeBeneficiario(index: number): string {
    return `CARGA_${index + 1}`;
  }

  public buildCreateCartSubscriptionPayload(): any {
    const titular = this.titularForm.value;
    const planSeleccionado = this.getPlanSeleccionado();
    const cantidadTitulares = 1;
    const cantidadBeneficiarios = this.getCantidadBeneficiariosActual();

    const beneficiariosPayload = this.getDeseaAgregarBeneficiarios() === 'SI'
      ? this.getBeneficiariosCompletadosControls().map((item) => {
        const beneficiario = item.control.value;

        return {
          car_det_person_type: this.getPersonTypeBeneficiario(item.index),
          car_det_rut: this.cleanRutForPayload(beneficiario.rut),
          car_det_email: beneficiario.email || null,
          car_det_name: beneficiario.nombre,
          car_det_paternal_surname: beneficiario.primerApellido,
          car_det_maternal_surname: beneficiario.segundoApellido || '',
          car_det_phone: null,
          car_det_birthdate: beneficiario.fechaNacimiento || null,
          car_det_is_holder: false,
          car_det_amount: this.getAmountBeneficiario(item.index)
        };
      })
      : [];

    return {
      datosPlan: {
        car_id_plan: Number(planSeleccionado?.cus_ben_id || titular.plan),
        car_origin: 'SELLER',
        car_total_amount: this.getTotalPlanMensual(),
        car_qty_titulares: cantidadTitulares,
        car_qty_beneficiarios: cantidadBeneficiarios
      },
      datosPacsTitular: {
        car_det_person_type: 'TITULAR',
        car_det_rut: this.cleanRutForPayload(titular.rut),
        car_det_email: titular.email,
        car_det_name: titular.nombre,
        car_det_paternal_surname: titular.primerApellido,
        car_det_maternal_surname: titular.segundoApellido || '',
        car_det_phone: this.getTelefonoCompletoTitular(),
        car_det_birthdate: titular.fechaNacimiento || null,
        car_det_is_holder: true,
        car_det_amount: this.getPrecioTitularPlan()
      },
      datosPacsBeneficiarios: beneficiariosPayload,
      datosVendedor: {
        car_seller_id: this.getSellerId(),
        car_seller_name: this.getSellerName()
      }
    };
  }

  private getCartPayloadHash(payload: any): string {
    return JSON.stringify(payload);
  }

  private getTokenFromResponse(response: any): string {
    return response?.token
      || response?.tokenCart
      || response?.token_cart
      || response?.car_token
      || response?.sub_car_token
      || response?.data?.token
      || response?.data?.tokenCart
      || response?.data?.token_cart
      || response?.data?.car_token
      || response?.data?.sub_car_token
      || response?.result?.token
      || response?.result?.tokenCart
      || response?.result?.token_cart
      || response?.result?.car_token
      || response?.result?.sub_car_token
      || response?.cart?.token
      || response?.cart?.tokenCart
      || response?.cart?.token_cart
      || '';
  }

  private getTokenCartSubscription(): string {
    return this.getTokenFromResponse(this.cartSubscriptionResponse || {});
  }

  private normalizarRespuestaCarro(resp: any, tokenAnterior: string): any {
    const tokenRespuesta = this.getTokenFromResponse(resp);

    if (tokenRespuesta || !tokenAnterior) {
      return resp;
    }

    return {
      ...(resp || {}),
      token: tokenAnterior
    };
  }

  private getPatientSubscriptionUrl(tokenCart: string): string {
    if (!tokenCart) {
      return '';
    }

    return `${window.location.origin}${window.location.pathname}${window.location.search}#/inscripcionConvenio/${tokenCart}`;
  }

  public async crearSolicitudEjecutivo(): Promise<boolean> {
    if (this.creatingCartSubscription) {
      return false;
    }

    if (!this.getSellerId()) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario no identificado',
        text: 'No fue posible obtener el ID del ejecutivo logueado. Vuelve a iniciar sesión e intenta nuevamente.',
        confirmButtonText: 'Aceptar'
      });
      return false;
    }

    const payloadBase = this.buildCreateCartSubscriptionPayload();
    const payloadHash = this.getCartPayloadHash(payloadBase);
    const tokenCart = this.getTokenCartSubscription();

    if (tokenCart && this.lastCartPayloadHash === payloadHash) {
      return true;
    }

    const payloadParaEnviar = {
      ...payloadBase,
      token: tokenCart || '',
      flujo: 'EJECUTIVO_PACIENTE'
    };

    this.creatingCartSubscription = true;

    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                  Generando solicitud ...
                </h1>
             </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const resp: any = await this.inscripcionService.postCreateUpdateCartSubscription(payloadParaEnviar);

      this.cartSubscriptionResponse = this.normalizarRespuestaCarro(resp, tokenCart);
      this.cartSubscriptionPayload = payloadBase;
      this.lastCartPayloadHash = payloadHash;
      this.generatedPatientUrl = this.getPatientSubscriptionUrl(this.getTokenCartSubscription());

      console.log('Payload postCreateCartSubscription ejecutivo:', payloadParaEnviar);
      console.log('Respuesta postCreateCartSubscription ejecutivo:', resp);
      console.log('URL paciente:', this.generatedPatientUrl);

      Swal.close();
      return true;

    } catch (error) {
      console.error('Error postCreateCartSubscription ejecutivo:', error);

      Swal.close();

      Swal.fire({
        icon: 'error',
        title: 'No fue posible generar la solicitud',
        text: 'Revisa la información ingresada e intenta nuevamente.',
        confirmButtonText: 'Aceptar'
      });

      return false;

    } finally {
      this.creatingCartSubscription = false;
    }
  }

  private async enviarCorreoPacienteConToken(): Promise<boolean> {
    const tokenCart = this.getTokenCartSubscription();

    if (!tokenCart) {
      Swal.fire({
        icon: 'warning',
        title: 'Token no encontrado',
        text: 'La solicitud fue generada, pero no fue posible obtener el token para enviar el correo al paciente.',
        confirmButtonText: 'Aceptar'
      });
      return false;
    }

    const payload = {
      token_cart: tokenCart
    };

    this.sendingMailPaciente = true;

    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">mail</i>
                <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                  Enviando correo al paciente ...
                </h1>
             </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const resp: any = await this.inscripcionService.postSendMailSellerPaciente(payload);
      this.sendMailResponse = resp;

      console.log('Payload postSendMailSellerPaciente:', payload);
      console.log('Respuesta postSendMailSellerPaciente:', resp);

      Swal.close();
      return true;

    } catch (error) {
      console.error('Error postSendMailSellerPaciente:', error);

      Swal.close();

      Swal.fire({
        icon: 'error',
        title: 'No fue posible enviar el correo',
        text: 'La solicitud fue generada, pero no fue posible enviar el enlace al paciente. Intenta nuevamente.',
        confirmButtonText: 'Aceptar'
      });

      return false;

    } finally {
      this.sendingMailPaciente = false;
    }
  }

  public async enviarSolicitudPaciente(): Promise<void> {
    if (this.loadingSubmit) {
      return;
    }

    this.markStep2Touched();
    this.markBeneficiariosStepTouched();
    this.validacionEjecutivoForm.markAllAsTouched();

    if (!this.isStep4Valid()) {
      Swal.fire({
        icon: 'warning',
        title: 'Formulario incompleto',
        text: 'Revisa los datos obligatorios y confirma la validación antes de enviar la solicitud al paciente.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    this.loadingSubmit = true;

    try {
      const solicitudGenerada = await this.crearSolicitudEjecutivo();

      if (!solicitudGenerada) {
        return;
      }

      const correoEnviado = await this.enviarCorreoPacienteConToken();

      if (!correoEnviado) {
        return;
      }

      this.showSuccessExecutiveScreen = true;

    } finally {
      this.loadingSubmit = false;
    }
  }

  // =========================================================
  // CONTACTO / HELPERS
  // =========================================================

  public contactarAlmamedis(): void {
    window.location.href = 'mailto:soporte@almamedis.cl';
  }

  public irAlInicio(): void {
    window.location.href = `${window.location.origin}/#/dashboard`;
  }

  public registrarOtroPaciente(): void {
    this.limpiarFormulario();
  }

  public getNombrePaciente(): string {
    const titular = this.titularForm.value;

    return `${titular.nombre || ''} ${titular.primerApellido || ''}`.trim() || 'el paciente';
  }

  private getPlanCardKey(plan: any): string {
    return String(plan?.cus_ben_id || plan?.id || plan?.cus_ben_name || '');
  }

  public isEspecialidadesPlanExpanded(plan: any): boolean {
    const key = this.getPlanCardKey(plan);
    return this.especialidadesExpandidasPorPlan[key] === true;
  }

  public toggleEspecialidadesPlan(plan: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    const key = this.getPlanCardKey(plan);

    if (!key) {
      return;
    }

    this.especialidadesExpandidasPorPlan[key] = !this.especialidadesExpandidasPorPlan[key];
  }

  public getEspecialidadesVisiblesPlan(plan: any): any[] {
    const especialidades = this.getEspecialidadesPlan(plan);

    if (this.isEspecialidadesPlanExpanded(plan)) {
      return especialidades;
    }

    return especialidades.slice(0, 3);
  }

  public getEspecialidadesOcultasCount(plan: any): number {
    const total = this.getEspecialidadesPlan(plan).length;

    return total > 3 ? total - 3 : 0;
  }

}